/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'
import { find } from 'lodash'

import type { StackDeployment, AsyncRequestState, ClusterSnapshot } from '@modules/ui-types'

import { getClusterSnapshots } from '@/reducers/clusterSnapshots'
import { fetchSnapshotsRequest } from '@/reducers/asyncRequests/registry'

import { fetchSnapshots } from '../../actions/snapshots'

import DeploymentSnapshotProgress from './DeploymentSnapshotProgress'

import type { ReduxState } from '@/types/redux'

type StateProps = {
  fetchSnapshotsRequest: AsyncRequestState
  snapshot: ClusterSnapshot | null
}

type DispatchProps = {
  fetchSnapshots: () => void
}

type ConsumerProps = {
  deployment: StackDeployment
}

const mapStateToProps = (state: ReduxState, { deployment }: ConsumerProps): StateProps => {
  const snapshots = getClusterSnapshots(state, deployment.id)
  const snapshot = find<ClusterSnapshot>(snapshots, { state: `IN_PROGRESS` }) || null

  return {
    fetchSnapshotsRequest: fetchSnapshotsRequest(state),
    snapshot,
  }
}

const mapDispatchToProps = (dispatch, { deployment }: ConsumerProps): DispatchProps => ({
  fetchSnapshots: () => dispatch(fetchSnapshots({ deployment })),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(DeploymentSnapshotProgress)
